"use client";

import { HeroSection } from "./_components/hero-section";
import { PortalSection } from "./_components/portal-section";
import { LeaderboardSpotlightSection } from "./_components/leaderboard-spotlight-section";
import { QuestsSpotlightSection } from "./_components/quests-spotlight-section";

export default function HomePage() {
  return (
    <div className="w-full">
      {/* Section 1: Hero - "Yiedl Portal" with tagline */}
      <HeroSection />

      {/* Section 2: What is the Yiedl Portal? - Quests, Referrals, Leaderboard cards */}
      <PortalSection />

      {/* Section 3: Leaderboard Spotlight - Top user showcase */}
      <LeaderboardSpotlightSection />

      {/* Section 4: Quests & Challenges - Social media quest cards */}
      <QuestsSpotlightSection />
    </div>
  );
}
